module.exports = __webpack_public_path__ + "img/00fab83693bf6bef0abe9ba0a9a0220c.386aa59d.jpg";